import { Component } from '@angular/core';
import { Input } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Cold50RaceLogin } from '../../../models/types';
import { OrganisationServiceService } from '../../services/organisation-service.service';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-cold50-prijava',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './cold50-prijava.component.html',
  styleUrl: './cold50-prijava.component.scss'
})
export class Cold50PrijavaComponent {

  @Input() isOrgAdmin: boolean = false;
  raceForm: FormGroup;
  racers: Cold50RaceLogin[] = [];

  constructor(private fb: FormBuilder, private organisationService: OrganisationServiceService) {
    this.raceForm = this.fb.group({
      name: ['', Validators.required],
      yearOfBirth: [null, Validators.required],
      sex: ['', Validators.required],
      phone: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      club: [''],
      numOfKm: [null, Validators.required],
      timeOfArrival: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.getRacers();
  }

  getRacers(): void {
    this.organisationService.getCold50Racers().subscribe((data: Cold50RaceLogin[]) => {
      this.racers = data;
    });
  }

  onSubmit(): void {
    if (this.raceForm.valid) {
      this.organisationService.enrollInCold50Race(this.raceForm.value).subscribe({
        next: (response) => {
          Swal.fire({
            icon: 'success',
            title: 'Uspešna prijava',
            text: 'Uspešno ste se prijavili na COLD50! Na vašo e-pošto smo poslali potrditveno sporočilo. Točno določen datum prireditve boste prejeli na e-pošto.',
          }).then(() => {
            window.location.reload();
          });
        },
        error: (error) => {
          Swal.fire({
            icon: 'error',
            title: 'Napaka pri prijavi',
            text: 'Prišlo je do napake pri prijavi. Poskusite znova.',
          });
        }
      });
    }
  }

    downloadCSV(): void {
      this.organisationService.downloadCold50csv().subscribe({
        next: (response: Blob) => {
          const url = window.URL.createObjectURL(response);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'cold50Tekmovalci.csv'; 
          link.click();
          window.URL.revokeObjectURL(url); 
        },
        error: (error) => {
          console.error('Error downloading CSV:', error);
        },
      });
    }

}
